import type { ILayoutBreadcrumb } from "src/contexts/layouts/LayoutContext";
import type { ModelIconName } from "src/icons";

// These collection destinations deliberately retain one symbol.
const unstackedModels = new Set<ModelIconName>([
    "permission",
    "trialMilestones",
    "trialApi",
    "institutionCapability",
    "trialCapability",
    "trialInstitutionCapability",
    "trialInstitutionSupportingSiteCapability"
]);

/**
 * Selects a single symbol for the explicit exception set and stacked icons for other models.
 */
export const collectionBreadcrumbStyle = (
    model: ModelIconName
): NonNullable<ILayoutBreadcrumb["iconStyle"]> =>
    unstackedModels.has(model) ? "single" : "collection";
